import React, { useState } from "react";
import { Link } from "react-router-dom";

import { api, formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      // The backend always returns 200 for valid email shapes — we
      // never surface whether that address matched a known owner.
      setSubmitted(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="bo-root" data-testid="forgot-password-screen">
      <div className="bo-login-shell">
        <div className="bo-login-card">
          <div className="bo-login-eyebrow" data-testid="forgot-eyebrow">
            Precipice Brand OS · Account recovery
          </div>
          <h1 className="bo-login-title" data-testid="forgot-title">
            Reset your password.
          </h1>
          <p className="bo-login-lede">
            Enter your workspace email. If it matches an account, we&rsquo;ll send a
            single-use reset link that expires in 30 minutes.
          </p>

          {submitted ? (
            <div
              className="bo-login-form"
              data-testid="forgot-success"
              style={{ marginTop: 8 }}
            >
              <div
                style={{
                  background: "var(--bo-surface-subtle, #f3f0ea)",
                  border: "1px solid var(--bo-border, #e6e2d8)",
                  padding: "14px 16px",
                  borderRadius: 6,
                  color: "var(--bo-ink, #2b2c30)",
                  lineHeight: 1.5,
                }}
                role="status"
              >
                If an account exists for <strong>{email.trim()}</strong>, a reset
                link is on its way. Check your inbox (and spam folder) within the
                next few minutes.
              </div>
              <Link
                to="/brand-os/login"
                className="bo-btn bo-btn-primary"
                data-testid="forgot-back-to-login"
                style={{ textAlign: "center", textDecoration: "none" }}
              >
                Back to sign in
              </Link>
            </div>
          ) : (
            <form
              className="bo-login-form"
              onSubmit={handleSubmit}
              data-testid="forgot-form"
            >
              <div className="bo-field">
                <label className="bo-label" htmlFor="bo-forgot-email">
                  Email
                </label>
                <input
                  id="bo-forgot-email"
                  className="bo-input"
                  data-testid="forgot-email-input"
                  type="email"
                  autoComplete="username"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@precipice-health.com"
                  disabled={busy}
                />
              </div>

              {error && (
                <div
                  className="bo-login-error"
                  data-testid="forgot-error"
                  role="alert"
                >
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="bo-btn bo-btn-primary"
                data-testid="forgot-submit-button"
                disabled={busy || !email}
              >
                {busy ? "Sending…" : "Send reset link"}
              </button>

              <Link
                to="/brand-os/login"
                data-testid="forgot-back-link"
                style={{
                  textAlign: "center",
                  fontSize: 13,
                  color: "var(--bo-muted, #6b6f76)",
                  textDecoration: "none",
                }}
              >
                Back to sign in
              </Link>
            </form>
          )}

          <div className="bo-login-footer">
            Reset links are single-use and expire in 30 minutes.
          </div>
        </div>
      </div>
    </div>
  );
}
